import { useLang } from "@/context/LanguageContext";
import { useScrollTo } from "@/hooks/useScrollTo";

export const Footer = () => {
  const { t } = useLang();
  const scrollTo = useScrollTo();
  const links = [
    [t("nav.mission"), "mission"], [t("nav.president"), "president"],
    [t("nav.galleries"), "galleries"], [t("nav.involved"), "involved"],
  ];
  return (
    <footer data-testid="footer" className="bg-[#F8F9FA] text-[#4B5563] border-t border-[#0A1128]/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img src="/logo.png" alt="Focus Haitian Music Inc." className="h-16 w-auto" />
            <p className="mt-6 max-w-sm leading-relaxed">{t("footer.tagline")}</p>
          </div>
          <div className="md:col-span-3 md:col-start-7">
            <p className="text-[#B8901F] text-xs uppercase tracking-[0.2em] font-semibold">{t("footer.explore")}</p>
            <ul className="mt-5 space-y-3">
              {links.map(([l, id]) => (
                <li key={id}>
                  <button onClick={() => scrollTo(id)} className="hover:text-[#B8901F] transition-colors">{l}</button>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-[#B8901F] text-xs uppercase tracking-[0.2em] font-semibold">{t("footer.giveZelle")}</p>
            <p className="mt-5 text-[#0A1128] font-medium">Herbert Joseph</p>
            <p className="mt-1">(347) 444-7776</p>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-[#0A1128]/10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm">
          <p>© {new Date().getFullYear()} Focus Haitian Music Inc. {t("footer.rights")}</p>
          <p className="text-[#0A1128]/50">{t("footer.values")}</p>
        </div>
      </div>
    </footer>
  );
};
